export default __webpack_public_path__ + "static/media/Roboto-MediumItalic.56a82359.ttf";